import React from "react";
import theme from "../helpers/theme";
import {CssBaseline} from "@material-ui/core";
import {ThemeProvider} from '@material-ui/core/styles';
import App from "./App";


const Root = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <App/>
        </ThemeProvider>
    );
}

export default Root;
